module.exports = __webpack_public_path__ + "img/logo-uuva-cloud.f0893e73.png";